import React, { useState, useEffect } from 'react';
import { useSelector } from 'umi';
import PageAccess from '@gp/components/PageAccess';
import { LEFT_MENU_NAMESPACE, GPOPLeftMenuModelState } from '@gp/models/gpopLeftMenuList';
import { PAGE_NO_ACCESS_DESCRIPTION } from '@gp/constants/noPermissionTips';

const Auth: React.FC<any> = (props) => {
  const { route } = props;

  const { menuList } = useSelector<any, GPOPLeftMenuModelState>((state) => state?.[LEFT_MENU_NAMESPACE] || {});

  const [title, setTitle] = useState('');
  const [isAccess, setIsAccess] = useState(false);
  const [accessDescription, setAccessDescription] = useState<string | React.ReactElement>('');

  useEffect(() => {
    let titleTmp = '';
    let isAccessTmp = false;

    if (menuList?.length) {
      for (let index = 0; index < menuList?.length; index++) {
        const item: any = menuList?.[index];
        if (item?.page_id === route?.access) {
          titleTmp = item?.name_en || '';
          isAccessTmp = item?.authority === 1;
          break;
        } else {
          if (item?.sub_menus?.length) {
            for (let i = 0; i < item?.sub_menus?.length; i++) {
              const t: any = item?.sub_menus?.[i];
              if (t?.page_id === route?.access) {
                titleTmp = t?.name_en || '';
                isAccessTmp = t?.authority === 1;
                break;
              }
            }
          }
        }
      }
    }

    setTitle(titleTmp);
    setIsAccess(isAccessTmp);
    setAccessDescription(PAGE_NO_ACCESS_DESCRIPTION?.[route?.access]);
  }, [menuList, route]);

  return (
    <PageAccess isAccess={isAccess} title={title} description={accessDescription}>
      {props.children}
    </PageAccess>
  );
};

export default Auth;
